import { useMemo } from "react";
import { mainRoutes } from "data/routes";
import { usePathname } from "next/navigation";
import findRoutePath from "utils/findPath";

export default function useBreadcrumbs() {
  const currentPath = usePathname();

  const pathArray = useMemo(() => {
    return findRoutePath(mainRoutes, currentPath);
  }, [currentPath]);

  const currentRoute = pathArray[pathArray.length - 1];

  const currentTitle = currentRoute
    ? currentRoute?.title || currentRoute?.label
    : "Default title";

  const breadcrumb = pathArray.map((route) => ({
    title: route.label,
    href: route.href,
  }));

  return {
    breadcrumb,
    currentPath,
    currentTitle,
    public: currentRoute?.public,
    readOnly: currentRoute?.readOnly,
  };
}
